// src/api/website-api/web-product.js
import axios from "axios";

// List & detail are the same vendor endpoint
const WEB_PRODUCT_DETAIL_API =
  `${process.env.REACT_APP_API_POS_WITH_WEBSITE}/api/vendor/products`;

const getLang = () => localStorage.getItem("lang") || "en";

const getLanguageHeaders = () => {
  const lang = getLang();
  return {
    "Accept-Language": lang,              // "en" or "ar"
    "Language-ID": lang === "ar" ? 4 : 1, // 4 for Arabic, 1 for English
  };
};

export const fetchWebProducts = async ({
  page = 1,
  pagelimit = 100,
  search = "",
  pop = true,
  categoryId,
} = {}) => {
  const token =
    localStorage.getItem("token") || localStorage.getItem("authToken");
  const storeId = localStorage.getItem("storeId");

  const headers = {
    ...getLanguageHeaders(),
  };

  // 🔐 add auth + store
  if (token) headers.Authorization = `Bearer ${token}`;
  if (storeId) headers["Store-ID"] = storeId;

  const params = { page, pagelimit };

  if (search) params.search = search;
  if (pop) params.pop = "";
  if (categoryId && categoryId !== "all") params.category_id = categoryId;

  const res = await axios.get(WEB_PRODUCT_DETAIL_API, { headers, params });

  const data = res.data;

  const products = Array.isArray(data?.data?.results)
    ? data.data.results
    : Array.isArray(data?.results)
    ? data.results
    : Array.isArray(data)
    ? data
    : Array.isArray(data?.data)
    ? data.data
    : Array.isArray(data?.products)
    ? data.products
    : [];

  console.log("🛰️ Raw product API data:", data);
  console.log("✅ Parsed products:", products);

  return products;
};

/**
 * Fetch single product by ID
 */
export const fetchWebProductById = async (productId) => {
  const token =
    localStorage.getItem("token") || localStorage.getItem("authToken");
  const storeId = localStorage.getItem("storeId") || 693877; // or 189460

  const headers = {
    ...getLanguageHeaders(),
    "Store-ID": storeId,
  };

  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await axios.get(`${WEB_PRODUCT_DETAIL_API}/${productId}`, {
    headers,
  });

  const p = res.data;

  return {
    ...p,
    _id: String(p.product_id || p.id || p._id),
    Product_Name:
      p.name || p.meta_title || p.model || (p.sku ? `SKU ${p.sku}` : "Unnamed"),
    CategoryId: p.categories?.length ? String(p.categories[0]) : "uncategorized",
    Price: Number(p.price ?? 0),
    Qty: Number(p.quantity ?? 0),
    image: p.image,
  };
};
